import React, { useCallback } from "react";
import { getRemoteKColorResults } from "@feature/remote-calculation-results";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

/**
 * Controlla che almeno in una survey c'è un prodotto kcolor restituisci true e apre il modale
 * Questo dato dev'essere passato a use survey products
 */
export const useCheckKcolorProducts = () => {
  const countryApiRequest = useCountryAxiosInstance();

  const fetch = useCallback(
    async (surveys: Number[]) => {
      let res = {};
      // 1. usare la promise KcolorResults x ogni survey
      for (let id of surveys) {
        const kColorResultsPromise = getRemoteKColorResults(
          parseInt(id),
          countryApiRequest
        );

        const [kColorResults] = await Promise.all([kColorResultsPromise]);
        // 2. per ogni survey scarcia il kcolorProducts (usa survey id come chiave)
        if (Object.keys(kColorResults).length > 0) {
          // 3. per ogni kcolorProducts, controlla se ci sono prodotti con kcolor
          res = {
            ...res,
            [id]: kColorResults,
          };
        }
      }

      return Object.keys(res).length > 0;
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

    return fetch;
};
